import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-mat-ngx-mat-dynamic-table',
  template: `
    <p>
      ngx-mat-dynamic-table works!
    </p>
  `,
  styles: [
  ]
})
export class NgxMatDynamicTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
